import { IMenuItem } from '.';
import { mainMenuTypes } from './menu.enum';

export const mainMenuBottom: IMenuItem[] = [
    {
        id: mainMenuTypes.HelpSupport,
        name: 'HELP_AND_SUPPORT',
        matchedLabel: 'HELP_AND_SUPPORT',
        component: 'HelpPage',
        icon: 'help',
        requiresPermission: false,
        linkChunk: 'help',
        link: '/apps/help'
    }
];
